import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { HeaderOld } from 'src/components/Header/HeaderOld';
import { MainMenu } from 'src/components/Header/LHSMenu/MainMenu';
import { MenuItemsType } from 'src/components/Header/LHSMenu/SideMenu/SideMenu';
import { LinkType } from 'src/components/Header/Links';
import { useCommon } from 'src/AppState/Common';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { PermissionGrantsState } from 'src/AppState/PermissionGrants/PermissionGrants.state';
import { Permission } from 'src/AppState/PermissionGrants/PermissionGrants.types';

export interface HeaderPropsType {
    onLogoutRequest: () => void;
    sideLinks?: Array<MenuItemsType>;
}

export const isMenuItemDisabled = (item: LinkType, permissionGrantsState: PermissionGrantsState): boolean => {
    if (item.route === 'global:reporting' && permissionGrantsState.has(Permission.walletReportingReports) === false) {
        return true;
    }

    if (item.route === 'global:cms' && permissionGrantsState.has(Permission.casinoAccessGames) === false) {
        return true;
    }

    if (item.route === 'global:casino' && permissionGrantsState.has(Permission.casinoAccessGames) === false) {
        return true;
    }

    return false;
};

export const Header = observer((props: HeaderPropsType) => {
    const { routerBackoffice } = useAppStateContext();
    const common = useCommon();
    const configState = ConfigState.get(common);
    const route = routerBackoffice.getValueString('global');

    if (
        (route === 'bonus-engine' || route === 'cmsV2' || route === 'tradingV2' || route === 'bet-tickerV2') &&
        configState.config.hasNewMenu === true
    ) {
        return (
            <MainMenu
                onLogoutRequest={props.onLogoutRequest}
                sideLinks={props.sideLinks}
            />
        );
    } else {
        return <HeaderOld onLogoutRequest={props.onLogoutRequest} />;
    }
});
